import type { ActionSuggestionBlock as ActionSuggestionBlockType } from '../types';
import { BlockEmptyState } from './BlockEmptyState';

// ─────────────────────────────────────────────
// ActionSuggestionBlock — 行动建议
// Figma: 每条建议为独立卡片 + 圆形序号 + 灰底
// ─────────────────────────────────────────────
export function ActionSuggestionBlock({ block }: { block: ActionSuggestionBlockType }) {
  const suggestions = block.suggestions ?? [];

  if (suggestions.length === 0) return <BlockEmptyState label="行动建议" />;

  return (
    <div className="flex flex-col gap-3">
      {suggestions.map((item, idx) => (
        <div key={idx} className="flex items-start gap-3 bg-[#F9FAFB] rounded-[8px] p-4">
          {/* 圆形序号 */}
          <div className="flex-shrink-0 w-7 h-7 rounded-full bg-[#E5E5E5] flex items-center justify-center">
            <span className="text-[12px] font-medium text-[#09090B]">{idx + 1}</span>
          </div>
          <p className="text-[14px] text-[#09090B] leading-[1.7] flex-1">{item}</p>
        </div>
      ))}
    </div>
  );
}
